// extracted by mini-css-extract-plugin
module.exports = {"container":"ComponentContainer_container__aOQbL","header":"ComponentContainer_header__2JVuR","content":"ComponentContainer_content__19N09"};